import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function IOTDevicePage() {

  const [rows, setRows] = useState([]);
  const [companies, setCompanies] = useState([]);
    const location = localStorage.getItem('userLocation');
  const [data, setData] = useState({
    company: "",
    device_id: "",
    type: "",
    is_active: true
  });

  useEffect(() => {
    fetchData();
    fetchCompanies();
  }, []);

  const fetchData = () => {
    axios.get(baseUrl + "iot-devices/")
      .then(res => {
        setRows(res.data);
      });
  };

  const fetchCompanies = () => {
    axios.get(baseUrl + 'view-hospital/' + location + '/')
      .then(res => {
        setCompanies(res.data);
      });
  };

  const inputHandler = (e) => {
    const { name, value, type, checked } = e.target;

    setData({
      ...data,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const formSubmit = () => {

    if (!data.company || !data.device_id || !data.type) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("company", data.company);
    _formData.append("device_id", data.device_id);
    _formData.append("type", data.type);
    _formData.append("is_active", data.is_active);
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "iot-devices/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then((response) => {

      if (response.status === 200 || response.status === 201) {

        Swal.fire({
          title: "Device Created",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setData({
          company: "",
          device_id: "",
          type: "",
          is_active: true
        });

        fetchData();
      }
    })
    .catch(() => {
      Swal.fire("Error", "Something went wrong", "error");
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Delete this device?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "iot-devices/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "Device deleted", "success");
            fetchData();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "company",
      headerName: "Company",
      flex: 1,
    renderCell: (params) => params.row.company?.company || "Unknown"
    },
    { field: "device_id", headerName: "Device ID", flex: 1 },
    { field: "type", headerName: "Type", flex: 1 },
    {
      field: "is_active",
      headerName: "Active",
      width: 120,
      renderCell: (params) => (
        <span className={params.row.is_active ? "text-success" : "text-danger"}>
          {params.row.is_active ? "Active" : "Inactive"}
        </span>
      )
    },
    { field: "add_date", headerName: "Date", width: 120 },

    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/iot-devices/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning"
        >
          Edit
        </Link>
      ),
      width: 120
    },

    {
      field: "delete",
      headerName: "Action",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm ms-1"
        >
          <i className="fa-solid fa-trash-can"></i>
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      {/* Form Card */}
      <div className="card p-4 mb-4">
        <h4>Add IoT Device</h4>

        <select
          className="form-control mt-3"
          name="company"
          value={data.company}
          onChange={inputHandler}
        >
          <option value="">Select Company</option>
          {companies.map(c => (
            <option key={c.id} value={c.id}>{c.company}</option>
          ))}
        </select>

        <input
          type="text"
          className="form-control mt-3"
          placeholder="Device ID"
          name="device_id"
          value={data.device_id}
          onChange={inputHandler}
        />

        <select
          className="form-control mt-3"
          name="type"
          value={data.type}
          onChange={inputHandler}
        >
          <option value="">Select Type</option>
          <option value="GPS">GPS</option>
          <option value="Temperature">Temperature</option>
          <option value="RFID">RFID</option>
        </select>

        <div className="form-check mt-3">
          <input
            type="checkbox"
            className="form-check-input"
            name="is_active"
            checked={data.is_active}
            onChange={inputHandler}
          />
          <label className="form-check-label">
            Active
          </label>
        </div>

        <button
          className="btn btn-success mt-3"
          onClick={formSubmit}
        >
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default IOTDevicePage;
